"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AUDIENCE_TARGETING_ESSENTIAL_RULES = exports.AUDIENCE_TARGETING_ADVANCED_RULES = void 0;
var AUDIENCE_TARGETING_ADVANCED_RULES = 'audience-targeting-advanced-rules';
exports.AUDIENCE_TARGETING_ADVANCED_RULES = AUDIENCE_TARGETING_ADVANCED_RULES;
var AUDIENCE_TARGETING_ESSENTIAL_RULES = 'audience-targeting-essential-rules';
exports.AUDIENCE_TARGETING_ESSENTIAL_RULES = AUDIENCE_TARGETING_ESSENTIAL_RULES;